module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/complaint_success.e6f1ec95.png";